import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';

import { UnreadBtnComponent } from './unread-btn.component';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, ReactiveFormsModule, FormsModule],
  declarations: [UnreadBtnComponent],
  exports: [UnreadBtnComponent],
})
export class UnreadBtnModule {}
